<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import { db } from "../database";
  import { user } from "../stores";
  let codeIsValid = false;
  let showValid = false;
  let saving = false;
  let code;

  $: if (code) {
    if (code.length > 3) {
      db.classes.idExisits(code).then((val) => {
        codeIsValid = !val;
        showValid = true;
      });
    } else {
      showValid = false;
      codeIsValid = false;
    }
  }

  const createClass = () => {
    saving = true;
    db.classes
      .add(code, $user.uid)
      .then((val) => {
        setTimeout(() => {
          dispatch("created", val);
        }, 450);
      })
      .catch((e) => console.error(e));
  };
</script>

<h1 class="title is-3">Create a Class</h1>
<p>To create your class, select a class name.</p>
<p>
  This will be the code your students use to join the class. <br />
  <!-- It can be any unique code - your name or the name of your class. -->
</p>
<br />
<div class="columns">
  <div class="column is-half is-offset-one-quarter">
    <div class="field">
      <label class="label" for="code">Class Code</label>
      <div class="control has-icons-right">
        <input
          id="code"
          class="input"
          type="text"
          placeholder="janefonda"
          class:is-success={showValid && codeIsValid}
          class:is-danger={showValid && !codeIsValid}
          bind:value={code}
        />
        {#if showValid && codeIsValid}
          <span class="icon is-small is-right">
            <i class="fa fa-check" />
          </span>
        {:else if showValid && !codeIsValid}
          <span class="icon is-small is-right">
            <i class="fa fa-exclamation-triangle" />
          </span>
        {/if}
      </div>
    </div>
    {#if codeIsValid}
      <div class="field">
        <button
          class="button is-primary is-block is-fullwidth is-medium"
          on:click={createClass}
          class:loading={saving}
        >
          Create Class
        </button>
      </div>
    {:else}
      <div class="field">
        <button
          class="button is-primary is-block is-fullwidth is-medium"
          disabled
        >
          Create Class
        </button>
      </div>
    {/if}
  </div>
</div>
